// removed by extract-text-webpack-plugin
module.exports = {"background":"_2W7Ay19P2e8h8M6HwtbFlI","navItem":"_37lfIrzHzvUuRhIeZa1OPw"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/app/App.css
// module id = 187
// module chunks = 0